import { ToDoParams } from 'app/models/todo-params'

/**
 * The To Do tab's KPI values. An empty list has no completion rate and no
 * deadline: 'N/A' for both, not "NaN%" and "Invalid Date" (LOS-7220).
 */
export function todoKpis(todos: ToDoParams[]): {
  percentageComplete: string
  deadlineApproaching: string
} {
  const completed = todos.filter(
    todo => todo.status?.toLocaleLowerCase() === 'completed',
  ).length
  const percentageComplete = todos.length
    ? Math.round((completed / todos.length) * 100).toString()
    : 'N/A'
  const due = todos[0]?.timeDue ? new Date(todos[0].timeDue) : undefined
  const deadlineApproaching =
    due && !isNaN(due.getTime())
      ? due.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      : 'N/A'
  return { percentageComplete, deadlineApproaching }
}
